export default __webpack_public_path__ + "static/media/qwiklabs6.6261447c.png";